import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";

import PrivateRoute from "../routes/PrivateRoute";

import Layout from "../layout/Layout";
import ChangePassword from "../auth/ChangePassword";
import ChangePasswordPos from "../auth/ChangePasswordPos";
import RegenerateUnauthorizedDocuments from "../auth/RegenerateUnauthorizedDocuments";
import Portal from "../portal/Portal";
import TermsOfUse from "../portal/TermsOfUsePage";
import Transactions from "../transactions/Transactions";
import ShiftClosure from "../transactions/ShiftClosure";
import RcofHistory from "../transactions/RcofHistory";
import AskForANewService from "../transactions/AskForANewService";
import ReceiveNewVoucherToProcess from "../transactions/ReceiveNewVoucherToProcess";
import TellAFriend from "../transactions/TellAFriend";
import Error500 from "../layout/Error500";
import Error404 from "../layout/Error404";
import HomeView from "../home/Home";
import Customers from "../customers/Customers"
import BillsList from '../bills/BillsList'
import NewBill from '../bills/NewBill'

const AppLayout = () => {
  return (
    <div>
      <Layout>
        <Switch>
          <PrivateRoute path="/app/home" component={HomeView} />
          <PrivateRoute path="/app/portal" component={Portal} />
          <PrivateRoute path="/app/customers" component={Customers} ><Customers type={1}/></PrivateRoute>
          <PrivateRoute path="/app/providers" component={Customers} ><Customers type={2}/></PrivateRoute>
          <PrivateRoute path="/app/bills-list" component={Customers} ><BillsList/></PrivateRoute>
          <PrivateRoute path="/app/new-bill" component={Customers} ><NewBill/></PrivateRoute>
          <PrivateRoute path="/app/transactions" component={Transactions} />
          <PrivateRoute path="/app/shift-closures" component={ShiftClosure} />
          <PrivateRoute path="/app/rcof-history" component={RcofHistory} />
          <PrivateRoute
            path="/app/change-password"
            component={ChangePassword}
          />
          <PrivateRoute
            path="/app/change-pos-password"
            component={ChangePasswordPos}
          />
          <PrivateRoute
            path="/app/regenerate-unauthorized-documents"
            component={RegenerateUnauthorizedDocuments}
          />
          <PrivateRoute
            path="/app/ask-for-a-new-service"
            component={AskForANewService}
          />
          <PrivateRoute
            path="/app/receive-new-voucher-to-process"
            component={ReceiveNewVoucherToProcess}
          />
          <PrivateRoute
            path="/app/tell-a-friend"
            component={TellAFriend}
          />
          <PrivateRoute
            path="/app/terms-of-use"
            component={TermsOfUse}
          />
          <PrivateRoute path="/app/error" component={Error500} />
          {/* <Redirect from="/app" to="/app/portal" exact /> */}
          {/*  <Route path="*">
            <Error404 />
          </Route> */}
          <Redirect from="/app" to="/auth" exact />
        </Switch>
      </Layout>
    </div>
  );
};

export default AppLayout;
